/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * @param {{ price: NonNullable<unknown>, fee: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_ticket_paid_share_info = (params) => `Let your friend pay the original price and service fee of ${params.price} + ${params.fee} - you will receive the funds within 3 business days after payment.`
